export const ImportMismoIntoLoanModalTestIds = {
  PREVIEW: 'importMismoIntoLoanModal.preview',
  SIDEBAR: 'importMismoIntoLoanModal.sidebar',
  SIDEBAR_ITEM: 'importMismoIntoLoanModal.sidebar-item',
  SECTION_GROUP: 'importMismoIntoLoanModal.section-group',
  CHANGE_CARD: 'importMismoIntoLoanModal.change-card',
  CANCEL_BUTTON: 'importMismoIntoLoanModal.cancel-button',
  PROCEED_BUTTON: 'importMismoIntoLoanModal.proceed-button',
};
